import React, { Fragment } from "react"
import ListViewModelContainer from "../ProductsView/ListViewModelContainer"
import GridViewModelContainer from "../ProductsView/GridViewModelContainer"

const ChassiSearchItemsContainer = ({category, index, isListView}) => { 
return (
        <div
          id={category.CategoryName}
          className="scroll-top-padding"
        >
          <div className="small-12 text--center">
            <h2>{category.CategoryDescription}</h2>
          </div>
          {category.PimItems &&
            category.PimItems.length > 0 &&
            category.PimItems.map((items, subindex) => (
              <Fragment key={isListView ? `chassi-fg-lv${subindex} ${index}` : `chassi-fg${subindex} ${index}`}>
                {items.ProductItems &&
                  items.ProductItems.length > 0 &&
                  items.ProductItems.filter(
                    (x) => x.IsExpired == false
                  ).length > 0 && (
                    <Fragment>
                      <div className="small-12 text--center">
                        <h3 className="category-name">
                          {items.SubCategoryHeading}
                        </h3>
                      </div>
                      {isListView ?
                      <ListViewModelContainer
                      heading={null}
                      excludeparsing={true}
                      products={items.ProductItems}
                      authenticated={'true'}
                      isChassiSearch={true}
                    ></ListViewModelContainer> :
                      <GridViewModelContainer
                        heading={null}
                        excludeparsing={true}
                        products={items.ProductItems}
                        authenticated={'true'}
                        isChassiSearch={true}
                      ></GridViewModelContainer>
                    }
                    </Fragment>
                  )}
              </Fragment>
            ))}
        </div>
)}

export default ChassiSearchItemsContainer

